import React from 'react';
import { MdSearch, MdCalendarToday, MdCheckCircle, MdOutlineRateReview } from 'react-icons/md';
import './HowItWorks.css';

const HowItWorks = () => {
    const steps = [
        {
            number: '01',
            title: 'Choose Service',
            description: 'Browse our wide range of services and select the one you need',
            icon: <MdSearch />
        },
        {
            number: '02',
            title: 'Book Professional',
            description: 'Pick your preferred time and choose from verified professionals',
            icon: <MdCalendarToday />
        },
        {
            number: '03',
            title: 'Get It Done',
            description: 'Our expert arrives on time and completes the job professionally',
            icon: <MdCheckCircle />
        },
        {
            number: '04',
            title: 'Rate & Review',
            description: 'Share your experience and help others make informed decisions',
            icon: <MdOutlineRateReview />
        }
    ];

    return (
        <section className="how-it-works-section section" id="how-it-works">
            <div className="container">
                <div className="section-header">
                    <h2>How It Works</h2>
                    <p>Get your service booked in 4 simple steps</p>
                </div>
                <div className="steps-container">
                    {steps.map((step, index) => (
                        <div key={index} className="step-card">
                            <div className="step-number">{step.number}</div>
                            <div className="step-icon">{step.icon}</div>
                            <h3 className="step-title">{step.title}</h3>
                            <p className="step-description">{step.description}</p>
                            {index < steps.length - 1 && (
                                <div className="step-connector"></div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
